import React from "react";
import {
  CalendarToday,
  Restaurant,
  Celebration,
  AttachMoney,
  Groups,
  Synagogue
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import EventMeta from '../../components/events/EventMeta';
import ImageCarousel from '../../components/events/ImageCarousel';
import KeyTakeaways from '../../components/events/KeyTakeaways';
import styled from 'styled-components';

const ClosingMessage = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  margin-top: 48px;
  margin-bottom: 80px;
  border: 1px solid rgba(0,0,0,0.1);

  h3 {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-text);
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    color: var(--color-text-light);
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }

  a {
    display: inline-block;
    margin-top: 20px;
    padding: 12px 24px;
    background: var(--color-primary-blue);
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 600;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      background: var(--color-accent);
    }
  }
`;

const Shabbat = () => {
  const eventData = {
    title: "Shabbat Open to Everyone",
    date: '04/04/2024',
    category: 'Cultural',
    description: 'We hosted a warm and welcoming Shabbat dinner where traditions met community spirit. Fifty participants experienced the beauty of Jewish customs, enjoyed delicious food, and connected with fellow students in a friendly atmosphere.',
    prices: {
      regular: 20,
      member: 16
    },
    media: [
      { src: '/events/shabbat_shalom/shabbat1.JPG', objectFit: 'cover', objectPosition: 'center' },
      { src: '/events/shabbat_shalom/shabbat2.JPG', objectFit: 'cover', objectPosition: 'center' },
      { src: '/events/shabbat_shalom/shabbat3.JPG', objectFit: 'cover', objectPosition: 'center' },
      { src: '/events/shabbat_shalom/shabbat4.JPG', objectFit: 'cover', objectPosition: '50% 65%' }
    ],
    registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSdelF7qFIg4rS_fWh5PPdZfs9wAbo_E1tb6eZNX3DwuMdRT2Q/viewform",
    highlights: [
      {
        icon: <Synagogue style={{ fontSize: '24px' }} />,
        title: 'Traditional Experience',
        description: 'Authentic Shabbat ceremonies and customs explained for everyone',
        color: '#4169E1'
      },
      {
        icon: <Restaurant style={{ fontSize: '24px' }} />,
        title: 'Kosher Dinner',
        description: 'Enjoy a delicious kosher meal prepared with care',
        color: '#4682B4'
      },
      {
        icon: <Groups style={{ fontSize: '24px' }} />,
        title: 'Community Building',
        description: 'Meet new friends and strengthen existing connections',
        color: '#1E90FF'
      }
    ]
  };

  const metaItems = [
    {
      icon: <CalendarToday style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #4169E1, #4682B4)',
      title: new Date('2024-04-04').toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }),
      subtitle: 'Event Date'
    },
    {
      icon: <AttachMoney style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #1E90FF, #4169E1)',
      title: `${eventData.prices.regular} CHF (${eventData.prices.member} CHF for members)`,
      subtitle: 'Event Price'
    }
  ];

  return (
    <EventLayout>
      <BackButton />

      <EventHero
        category={eventData.category}
        title={eventData.title}
        categoryIcon={<Celebration style={{ fontSize: '16px' }} />}
      >
        <EventMeta items={metaItems} />

        <p style={{
          fontSize: '18px',
          color: '#64748b',
          lineHeight: '1.8',
          marginBottom: '24px'
        }}>
          {eventData.description}
        </p>
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
        buttonGradient="linear-gradient(90deg, #4169E1, #4682B4)"
      />

      <KeyTakeaways items={eventData.highlights} />

      <ClosingMessage>
        <h3>✨ A Memorable Evening Together</h3>
        <p>
          What a beautiful celebration it was! We were delighted to share this special Shabbat evening
          with 50 wonderful participants. Together, we created a warm atmosphere of community, tradition,
          and friendship. From the traditional ceremonies to the delicious dinner, every moment
          was filled with joy and meaningful connections. Thank you to everyone who joined us in making
          this evening truly unforgettable!
        </p>
        <a
          href={eventData.registrationLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          Stay Tuned for Our Next Events!
        </a>
      </ClosingMessage>
    </EventLayout>
  );
};

export default Shabbat;